import Breadcrumb from 'shopper/components/Breadcrumb/V1/Breadcrumb';

import BreadcrumbItem from 'components/Breadcrumb/Item';

import placeholder from 'lib/placeholder';

import LINKS from 'constants/links';

const SuggestNewOfferHeading = (props) => (
  <Breadcrumb {...props}>
    <BreadcrumbItem href={LINKS.HOME}>
      {placeholder('breadcrumbs.offers')}
    </BreadcrumbItem>
    <BreadcrumbItem>{placeholder('breadcrumbs.suggestOffer')}</BreadcrumbItem>
  </Breadcrumb>
);

export default SuggestNewOfferHeading;
